export default "__VITE_ASSET__DKbPX7cj__"